import { createApiCall } from 'lib/base';
import { generateEndpoint } from '@ngtrvu/use-api';

const apiCall = type => {
  const FETCH_INVESTCORE_DATA_LIST_API_ID = `DASHBOARD/FETCH_INVESTCORE_WARDS_${type}`;

  return createApiCall(FETCH_INVESTCORE_DATA_LIST_API_ID, params => ({
    endpoint: generateEndpoint({
      host: `/api/admin/wards`,
      params,
    }),
    method: 'GET',
  }));
};

export default apiCall;
